// extracted by mini-css-extract-plugin
export default {"spinner__wrapper":"buttonLoader_spinner__wrapper__EnMBx","spinner":"buttonLoader_spinner__wlxfx"};